module.exports = __webpack_public_path__ + "img/selected1-min.91b236fc.png";